import { all, fork } from 'redux-saga/effects'

import locationChangeSaga from './locationChangeSaga'

export default function* unsavedChangesSaga() {
  yield all([fork(locationChangeSaga)])
}
